import React, { FunctionComponent } from 'react';
import styles from './PostCardTopBar.module.scss';
import { renderPlatformIcon } from 'app/utils/renderPlatformIcon';
import {
  LangIcon,
  LanguageIcon,
  QuoteIcon,
  ReplyIcon,
  SmallPinIcon,
  SmallSponsoredIcon,
} from 'app/assets/images/icons';
import { _t } from 'app/utils/i18n';
import DotsMenu from '../DotsMenu';
import Loader from '../Loader';
import { ReactComponent as RetweetIcon } from '../../assets/images/retweetIcon.svg';
interface Props {
  compId?: string;
  showConversationFlag?: boolean;
  showConversationPopupFlag?: boolean;
  translationToggle?: () => void;
  conversationRepliesLoad?: boolean;
  handleConvoFn?: () => Promise<void>;
  showConversation?: boolean;
  showQuoteIcon?: boolean;
  showReplyIcon?: boolean;
  showSponsored?: boolean;
  platformUrl: string;
  platform: string;
  postLanguages?: string[];
  showRetweetIcon?: boolean;
  content?: Record<string, string>;
  contentTranslated?: string;
  postId: number;
  showConversationPopup?: () => void;
  extraOptions?: unknown[];
  showRegrab?: boolean;
  showPinned?: boolean;
}

const PostCardTopBar: FunctionComponent<Props> = ({
  compId,
  showConversationFlag,
  translationToggle,
  conversationRepliesLoad,
  handleConvoFn,
  showConversation,
  platformUrl,
  postLanguages,
  showRetweetIcon,
  showQuoteIcon,
  showReplyIcon,
  content,
  contentTranslated,
  postId,
  platform,
  showSponsored,
  showConversationPopupFlag,
  showConversationPopup,
  extraOptions,
  showRegrab,
  showPinned,
}) => {
  return (
    <div className={`${styles.PostCardTopBar} 'p-line-10'`}>
      <div className={`${styles.postSection} ${styles.sectionSeparator} `}>
        <div className={styles.platformSection}>
          <div>
            <a href={platformUrl} target="_blank" rel="noreferrer">
              <div className={`${styles.iconText} '.mr-5'`}>
                {renderPlatformIcon(platform, true)}
                <span style={{ color: 'var(--secondaryColor)' }}>
                  {_t(`basic:${platform?.toLowerCase()}`)}
                </span>
              </div>
            </a>
          </div>
          {postLanguages && postLanguages?.[0]?.length > 0 && (
            <div className={`${styles.iconText} '.mr-5'`}>
              <LanguageIcon />

              <span>{postLanguages?.join(',')}</span>
            </div>
          )}
          {showRetweetIcon ? (
            <div>
              <span className={`${styles.retweet} '.mr-5'`}>
                <RetweetIcon />
              </span>
            </div>
          ) : (
            <></>
          )}
          {showQuoteIcon && (
            <div className={`${styles.conversations} '.mr-5'`}>
              <QuoteIcon />
              <div> {_t('tweets:quote')}</div>
            </div>
          )}
          {showReplyIcon && (
            <div className={`${styles.conversations} '.mr-5'`}>
              <ReplyIcon />
              <div> {_t('basic:reply')}</div>
            </div>
          )}
          {showSponsored && (
            <div className={`${styles.conversations} '.mr-5'}`}>
              <SmallSponsoredIcon />
              <div> {_t('posts:sponsored')}</div>
            </div>
          )}
          {showPinned && (
            <div className={`${styles.conversations} '.mr-5'}`}>
              <SmallPinIcon />
              <div> {_t('posts:pin')}</div>
            </div>
          )}
          {showReplyIcon && showConversationFlag && (
            <div
              className={styles.conversations}
              style={{
                cursor: 'pointer',
                position: 'relative',
              }}
              onClick={handleConvoFn}
            >
              {!!conversationRepliesLoad ? (
                <div style={{ marginInlineStart: '40px' }}>
                  <Loader smallSize />
                </div>
              ) : (
                <>
                  <ReplyIcon />
                  <div>
                    {showConversation
                      ? _t('basic:hide_Conversations')
                      : _t('basic:Show_Conversations')}
                  </div>
                </>
              )}
            </div>
          )}
          {showConversationPopupFlag && (
            <div
              className={styles.conversations}
              style={{
                cursor: 'pointer',
                position: 'relative',
              }}
              onClick={showConversationPopup}
            >
              <ReplyIcon />
              <div>{_t('basic:Show_Conversations')}</div>
            </div>
          )}
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>
          {(contentTranslated || content?.arabic) && (
            <div
              className={styles.langIcon}
              data-testid="LangIcon-holder"
              onClick={() => translationToggle?.()}
            >
              <LangIcon />
            </div>
          )}
        </div>
        <DotsMenu
          extraOptions={extraOptions}
          id={compId}
          showRegrab={showRegrab}
          dataId={postId}
        />
      </div>
    </div>
  );
};

export default PostCardTopBar;
